import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
const buttonWrapperCss = "b47o0xa";
export const ButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonWrapperCss, props.className)} />;
});
const buttonTextCss = "b4kwd06";
export const ButtonText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(buttonTextCss, props.className)} />;
});
const menuIsTabletUpCss = "mypkqfu";
const menuWideCss = "mezbcyx";
const menuDropdownOnRightCss = "m14p5qpf";
const menuIsMobileCss = "m1s9su0f";
const menuCss = "mq4e235";
export const Menu = forwardRef((props, ref) => {
  const {
    wide,
    dropdownOnRight
  } = props;
  const isTabletUp = useDeviceType('isTabletUp');
  const isMobile = useDeviceType('isPhone');
  return <ViewportDropdownMenu ref={ref} {...props} className={classNames(menuCss, {
    [menuIsTabletUpCss]: isTabletUp,
    [menuWideCss]: wide,
    [menuDropdownOnRightCss]: dropdownOnRight,
    [menuIsMobileCss]: isMobile
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");